export default {
  privacy: {
    badge: 'CONFIDENTIALITÉ',
    title: 'Politique de confidentialité',
    updated: 'Dernière mise à jour : septembre 2026',
    sections: [
      {
        title: '1. Responsable du traitement',
        blocks: [
          { type: 'p', text: 'La présente politique de confidentialité explique comment Limpia Sàrl traite les données personnelles des visiteurs de son site internet et de ses clients.' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Suisse' },
          { type: 'p', text: 'IDE/TVA : CHE-427.499.887' },
          { type: 'p', text: "Pour toute question concernant la protection des données, vous pouvez nous contacter à l'adresse e-mail indiquée sur notre site internet." },
        ],
      },
      {
        title: '2. Données personnelles collectées',
        blocks: [
          { type: 'p', text: 'Lorsque vous utilisez notre site internet, nous pouvons traiter les données personnelles que vous nous transmettez volontairement, notamment lorsque vous :' },
          { type: 'li', text: 'nous contactez par e-mail ;' },
          { type: 'li', text: 'utilisez notre formulaire de contact ;' },
          { type: 'li', text: 'demandez une offre ou un devis ;' },
          { type: 'li', text: 'demandez des informations concernant nos services ;' },
          { type: 'li', text: "communiquez avec nous dans le cadre d'une relation commerciale." },
          { type: 'p', text: 'Selon la nature de votre demande, les données peuvent notamment comprendre :' },
          { type: 'li', text: 'nom et prénom ;' },
          { type: 'li', text: 'adresse e-mail ;' },
          { type: 'li', text: 'numéro de téléphone ;' },
          { type: 'li', text: 'adresse postale ;' },
          { type: 'li', text: 'informations relatives à votre demande ;' },
          { type: 'li', text: 'toute autre information que vous choisissez de nous communiquer.' },
          { type: 'p', text: "Nous pouvons également traiter certaines données techniques générées automatiquement lors de la consultation du site, telles que l'adresse IP, le type de navigateur, le système d'exploitation, la date et l'heure de la consultation et les pages visitées." },
        ],
      },
      {
        title: '3. Finalités du traitement',
        blocks: [
          { type: 'p', text: 'Nous traitons les données personnelles uniquement dans la mesure nécessaire, notamment afin de :' },
          { type: 'li', text: 'répondre à vos demandes ;' },
          { type: 'li', text: 'établir et transmettre des offres ou devis ;' },
          { type: 'li', text: 'fournir nos prestations ;' },
          { type: 'li', text: 'gérer notre relation avec nos clients et partenaires ;' },
          { type: 'li', text: 'assurer le fonctionnement et la sécurité du site internet ;' },
          { type: 'li', text: 'améliorer nos services et notre présence en ligne ;' },
          { type: 'li', text: 'respecter nos obligations légales et réglementaires.' },
        ],
      },
      {
        title: '4. Formulaire de contact',
        blocks: [
          { type: 'p', text: 'Lorsque vous utilisez le formulaire de contact disponible sur notre site, les informations saisies sont transmises à Limpia Sàrl afin que nous puissions traiter votre demande.' },
          { type: 'p', text: 'Les données communiquées via le formulaire ne sont pas utilisées à des fins publicitaires sans base légale appropriée ou, lorsque cela est nécessaire, sans votre consentement.' },
          { type: 'p', text: 'Nous vous recommandons de ne pas transmettre via le formulaire des informations sensibles qui ne sont pas nécessaires au traitement de votre demande.' },
        ],
      },
      {
        title: '5. Communication des données à des tiers',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl ne vend pas vos données personnelles.' },
          { type: 'p', text: "Dans le cadre de l'exploitation de notre site internet et de nos activités, certaines données peuvent être traitées par des prestataires externes lorsque cela est nécessaire, par exemple :" },
          { type: 'li', text: 'hébergeur du site internet ;' },
          { type: 'li', text: 'prestataire de messagerie électronique ;' },
          { type: 'li', text: 'prestataire technique chargé de la maintenance du site ;' },
          { type: 'li', text: "outils d'analyse ou de statistiques, lorsqu'ils sont utilisés ;" },
          { type: 'li', text: 'autres prestataires nécessaires à la fourniture de nos services.' },
          { type: 'p', text: 'Ces prestataires peuvent traiter des données personnelles uniquement dans le cadre de leurs prestations et conformément aux exigences légales applicables.' },
          { type: 'p', text: "Lorsque des données personnelles sont transférées vers un pays situé hors de Suisse ou de l'Espace économique européen, nous veillons à ce que les conditions légales applicables à ce transfert soient respectées." },
        ],
      },
      {
        title: '6. Cookies',
        blocks: [
          { type: 'p', text: "Notre site internet peut utiliser des cookies et technologies similaires afin d'assurer son bon fonctionnement, d'améliorer l'expérience utilisateur et, le cas échéant, d'obtenir des statistiques de fréquentation." },
          { type: 'p', text: 'Les cookies peuvent notamment permettre au site de mémoriser certaines préférences ou de garantir certaines fonctionnalités techniques.' },
          { type: 'p', text: 'Lorsque des cookies ou technologies de suivi nécessitent votre consentement, celui-ci est demandé conformément aux exigences légales applicables.' },
          { type: 'p', text: 'Vous pouvez également configurer votre navigateur afin de limiter ou de bloquer certains cookies. La désactivation de certains cookies peut toutefois affecter le fonctionnement du site.' },
        ],
      },
      {
        title: "7. Outils d'analyse et services externes",
        blocks: [
          { type: 'p', text: "Si des outils d'analyse, de statistiques, de cartographie, de vidéos ou d'autres services externes sont intégrés à notre site, ceux-ci peuvent traiter certaines données techniques relatives à votre utilisation du site." },
          { type: 'p', text: 'Les services effectivement utilisés sur le site sont indiqués dans la présente politique de confidentialité et, lorsque cela est nécessaire, dans notre gestionnaire de cookies.' },
        ],
      },
      {
        title: '8. Durée de conservation',
        blocks: [
          { type: 'p', text: 'Nous conservons les données personnelles uniquement pendant la durée nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées.' },
          { type: 'p', text: 'Lorsque des obligations légales de conservation existent, certaines données peuvent être conservées pendant la durée imposée par la législation applicable.' },
          { type: 'p', text: "À l'expiration de cette période, les données sont supprimées ou anonymisées lorsque cela est techniquement possible et légalement approprié." },
        ],
      },
      {
        title: '9. Sécurité des données',
        blocks: [
          { type: 'p', text: "Nous mettons en œuvre des mesures techniques et organisationnelles appropriées afin de protéger les données personnelles contre la perte, l'utilisation abusive, l'accès non autorisé, la modification ou la divulgation." },
          { type: 'p', text: 'Toutefois, aucune transmission de données sur Internet ni aucun système informatique ne peut garantir une sécurité absolue.' },
        ],
      },
      {
        title: '10. Vos droits',
        blocks: [
          { type: 'p', text: 'Dans les limites prévues par la législation applicable, vous disposez notamment du droit :' },
          { type: 'li', text: 'de demander des informations sur les données personnelles que nous traitons à votre sujet ;' },
          { type: 'li', text: 'de demander la correction de données personnelles inexactes ;' },
          { type: 'li', text: 'de demander la suppression de vos données lorsque les conditions légales sont remplies ;' },
          { type: 'li', text: 'de vous opposer à certains traitements de vos données ;' },
          { type: 'li', text: 'de demander, lorsque la loi le prévoit, la remise ou la transmission de vos données dans un format approprié.' },
          { type: 'p', text: "Pour exercer vos droits ou obtenir des informations concernant le traitement de vos données personnelles, vous pouvez nous contacter à l'adresse e-mail indiquée sur notre site." },
        ],
      },
      {
        title: '11. Liens vers des sites tiers',
        blocks: [
          { type: 'p', text: 'Notre site peut contenir des liens vers des sites internet exploités par des tiers.' },
          { type: 'p', text: "Limpia Sàrl n'est pas responsable du contenu, des pratiques de confidentialité ou du traitement des données effectué par ces sites tiers." },
          { type: 'p', text: 'Nous vous recommandons de consulter les politiques de confidentialité des sites concernés avant de leur transmettre des données personnelles.' },
        ],
      },
      {
        title: '12. Modifications de la présente politique',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl peut modifier la présente politique de confidentialité lorsque cela est nécessaire, notamment en raison de changements légaux, techniques ou organisationnels.' },
          { type: 'p', text: 'La version publiée sur notre site internet est la version applicable.' },
        ],
      },
      {
        title: '13. Contact',
        blocks: [
          { type: 'p', text: "Pour toute question relative à la protection des données ou à l'utilisation de vos données personnelles, veuillez contacter :" },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Suisse' },
          { type: 'p', text: 'E-mail : info@limpiasarl.ch' },
        ],
      },
    ],
  },
};